module.exports = __webpack_public_path__ + "static/virtual-reality-american-society-for-cytotechnology-13a18a188535a012480594d48c2a59bf.jpg";